import React from 'react';
import DashboardIcon from './icons/DashboardIcon';

const prevent = (handler) => (event) => {
  event.preventDefault();
  if (handler) handler(event);
};

export function RowActions({
  alignEnd = false,
  showEdit = true,
  showDuplicate = false,
  onEdit,
  onDelete,
  onDuplicate,
}) {
  return (
    <div className="row-actions" style={alignEnd ? { justifyContent: 'flex-end' } : undefined}>
      {showEdit ? (
        <button className="row-action-btn" type="button" title="Edit" onClick={prevent(onEdit)}>
          <DashboardIcon name="edit" size={14} strokeWidth="2" />
        </button>
      ) : null}
      <button className="row-action-btn row-action-btn--danger" type="button" title="Delete" onClick={prevent(onDelete)}>
        <DashboardIcon name="trash" size={14} strokeWidth="2" />
      </button>
      {showDuplicate ? (
        <button className="row-action-btn" type="button" title="Duplicate" onClick={prevent(onDuplicate)}>
          <DashboardIcon name="duplicate" size={14} strokeWidth="2" />
        </button>
      ) : null}
    </div>
  );
}

export default RowActions;
